export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
};

export const severityColor = (sev) => {
  if (sev === "high") return { fg: "#D93636", bg: "#FBEAE9" };
  if (sev === "medium") return { fg: "#F29F05", bg: "#FDF4E6" };
  return { fg: "#40593B", bg: "#EDF2EB" };
};

export const sentimentColor = (s) => {
  if (s === "negative") return "#D93636";
  if (s === "positive") return "#40593B";
  return "#8C8C8C";
};

export const channelLabel = {
  online: "Online",
  retail: "Retail",
  distributor: "Distributor",
  importer: "Importer",
};

export const regionsList = [
  "EU",
  "USA",
  "UK",
  "India",
  "GCC",
  "China",
  "South Korea",
];
